import { Helmet } from 'react-helmet'
import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import ConfirmModal from '../../components/modals/confirmModal'

export default function ExternalRecruitersSettingsPage() {
  const [emailSent, setEmailSent] = useState(false)

  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const apiEndpoint =
    'https://hook.us1.make.com/30lqq0h5umaqa19qrg1sxmcf3hogv93a'

  return (
    <div className="pt-6">
      <Helmet>
        <title>Settings &gt; External Recruiters</title>
      </Helmet>

      <h2>External Recruiters</h2>
      <p>
        External agencies we use for recruiting. This this is used to share
        positions updates:
      </p>

      <iframe
        className="-pt-7 h-[75vh] w-full rounded-md border border-dotted border-[var(--border-grey)]"
        title="Recruiters table"
        src="https://docs.google.com/spreadsheets/d/1YjO9oSu00ajRkhrIz8jotmUZbqARFJk7rwgEOIzYTBs/edit#gid=0"
      />

      <div className="mt-10">
        {emailSent ? (
          <b>Email sent successfully!</b>
        ) : (
          <Button primary onClick={() => setShowConfirmDialog(true)}>
            Send Positions Email!
          </Button>
        )}
      </div>

      <ConfirmModal
        show={showConfirmDialog}
        title="Sending Positions Email!"
        question="You are about to send positions email to all external recruiters?"
        onConfirm={async () => {
          try {
            await fetch(apiEndpoint, {
              method: 'GET',
            })

            setEmailSent(true)
          } catch (error) {
            console.error('Error sending positions email:', error)
          } finally {
            setShowConfirmDialog(false)
          }
        }}
        onCancel={() => setShowConfirmDialog(false)}
      ></ConfirmModal>
    </div>
  )
}
